import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useFilterAccess from 'components/Filters/hooks/useFilterAccess';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { useFilters } from 'hooks/useFilters';

import formatOptionsWithLabel from 'utils/formatOptionsWithLabel';
import { sortStageAndStatusDropdownOptions } from 'utils/sortStageAndStatusDropdownOptions';
import { filterOutInReviewJobStatusOptions } from 'utils/filterJobStatusOptions';
import { AppModules, Dictionaries, FilterFields } from 'constants/enums';

import FilterWrapper from './common/FilterWrapper';
import CheckboxGroup from './components/CheckboxGroup';

const JobsFilters = () => {
  const { t } = useTranslation();
  const { hasAccessToFilter } = useFilterAccess('jobFilters');
  const { filters, updateFilter, isLoading } = useFilters(AppModules.Jobs);
  const jobStatuses = useSelector(selectDictionary(Dictionaries.JobStatus));

  const { status } = filters;

  const jobsStatusesOptions = formatOptionsWithLabel(
    sortStageAndStatusDropdownOptions(jobStatuses, Dictionaries.JobStatus)
  );

  const filteredJobsStatusesOptions = filterOutInReviewJobStatusOptions(jobsStatusesOptions);

  const handleStatusChange = (value: string[]) => {
    updateFilter(FilterFields.Status, value);
  };

  return (
    <FilterWrapper>
      <CheckboxGroup
        title={t('filters.jobs.status.title')}
        value={status}
        options={filteredJobsStatusesOptions}
        onChange={handleStatusChange}
        hasAccessToFilter={hasAccessToFilter(FilterFields.Status)}
        disabled={isLoading}
      />
    </FilterWrapper>
  );
};

export default JobsFilters;
